import React, { useEffect, useState } from 'react';
import FilterDropdown from '../Filter/components/FilterDropdown';
import { translate } from '../../services/translate';
import { useQuery } from '@tanstack/react-query';
import { appAgentService } from '../../services/central-api/app-agent';
import { useAuth } from '../../context/Auth';
import { StyleProp, TextStyle, ViewStyle } from 'react-native';
import { useIsFocused } from '@react-navigation/native';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex?: number;
    disabled?: boolean;
    labelFontSize?: number;
    label?: string;
    required?: boolean;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<ViewStyle>;
}

export default function PatrolIndicatorDropdown({ value, setValue, disabled, label, labelFontSize, zIndex, required, labelStyle, viewStyle }: Props) {
    const { user: authenticatedUser } = useAuth();

    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    const isFocused = useIsFocused();
    const queryResult = useQuery({
        queryKey: ['getSimplifiedPatrolIndicators'],
        queryFn: () => appAgentService.getSimplifiedPatrolIndicators(),
        enabled: !!authenticatedUser && isFocused,
    });

    const isEnabled = !!authenticatedUser;
    const isLoading = isEnabled && queryResult.isFetching;
    const { data } = queryResult;

    useEffect(() => {
        if (!authenticatedUser || !data) {
            return;
        }

        setItems(data.map(indicator => ({
            label: `${indicator.code} - ${indicator.name}`, value: indicator.id
        })));
    }, [data, authenticatedUser]);

    return (
        <FilterDropdown
            label={label ?? translate('patrolIndicators')}
            items={items}
            multiple={false}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
            disabled={disabled || isLoading}
            labelFontSize={labelFontSize}
            loading={isLoading}
            required={required}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
